import styled from 'styled-components/macro';

import { ReactComponent as CalendarExpiredSvg } from 'components/svg/CalendarExpired.svg';
import { large } from 'styles/breakpoints';
import { container } from 'styles/layout';
import { eyebrow, formHeadingThin, heading } from 'styles/typography';
import { IWithThemeProps } from 'typings';

export const Container = styled.div`
  ${container}
  min-height: 400px;

  padding: 0px 25px;
`;

export const Header = styled.h1`
  ${heading}
  margin: 26px 0;
  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const SubHeader = styled.h2`
  ${eyebrow}
  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
  margin-bottom: -8px;
`;

export const Description = styled.h3`
  ${formHeadingThin}
  ${({ theme }: IWithThemeProps) => `
    color: ${theme.topForegroundPrimary};
  `}
`;

export const CalendarImage = styled(CalendarExpiredSvg)`
  margin-bottom: 8px;

  ${large`
    margin-top: -20px;
  `}
`;

export const Logo = styled.div`
  display: block;
  height: 120px;
  margin: -15px auto 35px auto;

  ${({ theme }: IWithThemeProps) => `
    background: center / contain url(${theme.logoUrl}) no-repeat;
  `}

  ${large`
    display: none;
    width: 386px;
  `}
`;
